import useIsMobile from "@/hooks/useIsMobile";
import PageLayout from "@/screens/Layout/PageLayout";

import GoldSilverRatesPage from "@/screens/GoldSilverRates";

export default function GoldRates({
  categoryListData = null,
  latestStoryData = null,
  latestVideoData = null,
  city = null,
  city_hn = null,
  silverRatesData = null,
  silverCityData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <GoldSilverRatesPage
          categoryListData={categoryListData}
          silverRatesData={silverRatesData}
          city={city}
          city_hn={city_hn}
          isMobileDevice={isMobileDevice}
          type={"silver"}
          silverCityData={silverCityData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const { getSilverDataForCity, getSilverDataMultiCity } = await import("@/handlers/goldSilver");
  const { getGoldSilverCitiesAndStates, getStateSlugForLocation } = await import("@/component/GoldSilver/cityList");
  const cities = getGoldSilverCitiesAndStates();

  try {
    const slug = ctx?.params?.slug ?? "";

    // Validate slug matches expected pattern: {city}-gold-price-today
    if (!slug.endsWith("-silver-price-today")) {
      return { notFound: true };
    }

    const city = slug.replace(/-silver-price-today$/, "");
    let url = ctx?.resolvedUrl;
    url = url.split("?")[0];
    const normalize = (str = "") =>
      str?.toLowerCase()?.replace(/-/g, " ")?.trim();
    const city_hn = cities.find((c) => c.city.toLowerCase() === normalize(city))?.city_hn ?? city.charAt(0).toUpperCase() + city.slice(1);
    const city_en = cities.find((c) => c.city.toLowerCase() === normalize(city))?.city ?? city.charAt(0).toUpperCase() + city.slice(1);
    // if city hn is not found then return 404 
   

    const cityInHindi = cities.find(
      c => normalize(c.city) === normalize(city)
    )?.city_hn;
    if (!cityInHindi) return { notFound: true };
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");

    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import(
      "@/handlers/commonApi"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const { parseSilverData, parseSilverMultiCityData } = await import("@/utils/goldSilverParser");
    const unixtime = getUnixTimeDaysAgo(15);


    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;
    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "silver-rates",
        page: page,
        display: 12,
        type: "all",
      },
    });

    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [categoryListData, { latestStoryData, latestVideoData }, silverDataForCity, silverCityData] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: "silver-rates",
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      getSilverDataForCity({ city }),
      getSilverDataMultiCity(),
    ]);
    if (!silverDataForCity) return { notFound: true };
    const parsedSilverData = parseSilverData(silverDataForCity?.data);
    const stateSlug = getStateSlugForLocation(city_en);
    const parsedSilverCityData = parseSilverMultiCityData(silverCityData?.data, stateSlug);
    let headerCache = 300
    setPageTTL(ctx, headerCache);

    return {
      props: {
        categoryListData,
        latestStoryData,
        latestVideoData,
        city: city_en,
        city_hn,
        silverRatesData: parsedSilverData,
        silverCityData: parsedSilverCityData
      },
    };
  } catch (error) {
    logger.error(error);
    return { notFound: true };
  }
};
